<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $t('messages.shop'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex space-x-2">
            <div>
                <aside class="justify-self-center">
                    <nav
                        class="inline-flex flex-wrap items-center justify-center p-1 space-x-1 overflow-hidden text-sm text-gray-600 bg-gray-100 rounded-xl"
                    >
                        <template v-for="link in meta.links.menu" :key="link.url">
                            <AppButton as="inertia-link" :href="link.url" v-if="link.selected">
                                {{ link.display_name }}
                            </AppButton>
                            <inertia-link
                                v-else
                                :href="link.url"
                                class="inline-flex items-center h-8 px-5 font-medium transition rounded-lg hover:text-gray-800 focus:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-inset"
                            >
                                {{ link.display_name }}
                            </inertia-link>
                        </template>
                    </nav>
                </aside>
            </div>
        </div>

        <EmptyState picture v-if="items.length === 0">
            <template v-slot:picture />
        </EmptyState>
        <div v-else class="mt-5">
            <div class="md:grid md:grid-cols-3 lg:grid-cols-6 md:gap-6">
                <div v-for="item in items" :key="item.id">
                    <img :src="item.image_path" alt="" />
                    <div>
                        {{ item.name }}
                    </div>
                    <div class="flex justify-between items-center">
                        <div>
                            <BadgePill color="yellow">
                                {{ item.price }}
                            </BadgePill>
                        </div>
                        <InertiaLinkButton as="button" :href="item.url" type="white" method="post">
                            {{ $t('messages.buy') }}
                        </InertiaLinkButton>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import InertiaLinkButton from '@/components/InertiaLinkButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import BadgePill from '@/components/BadgePill.vue';

export default {
    components: {
        EmptyState,
        PanelPage,
        AppButton,
        InertiaLinkButton,
        BadgePill,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'items', 'filters'],
    data() {
        return {
            form: this.$inertia.form({
                search: this.filters.search,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
